import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { RouterStateService } from '../../../../core/routing/router-state.service';
import { StoresService } from '../../../../core/services/stores';
import { LayoutService } from '../../layout.service';

@UntilDestroy()
@Component({
    selector: 'app-nav-bar-mobile',
    templateUrl: './nav-bar-mobile.component.html',
    standalone: false,
})
export class NavBarMobileComponent implements OnInit {
    heading: string = '';
    constructor(
        private layoutService: LayoutService,
        private storesService: StoresService,
        private routerStateService: RouterStateService
    ) {}

    ngOnInit() {
        this.getHeading();
        this.routerStateService.routeChanged$.pipe(untilDestroyed(this)).subscribe((route) => {
            this.getHeading();
        });
    }

    toggleMainMenu(e: Event) {
        if (e) {
            e.preventDefault();
        }
        this.layoutService.isSidebarClosed = !this.layoutService.isSidebarClosed;
        this.storesService.mobileMenuToggle({ id: 'sidebar2', active: !this.layoutService.isSidebarClosed });
    }

    getHeading() {
        const currentUrlRoute = this.routerStateService.getCurrentUrlRoute();
        let heading = '';
        switch (currentUrlRoute) {
            case '/estimates/list':
            case '/estimates/create':
            case '/estimates/ai-estimate':
                heading = 'estimates';
                break;
            case '/jobs/list':
                heading = 'jobs';
                break;
            case '/jobs/orders':
                heading = 'orders';
                break;
            case '/jobs/invoices':
                heading = 'invoices';
                break;
            case '/jobs/accounting/import-bills':
                heading = 'accounting-import';
                break;
            case '/jobs/import-timesheets':
                heading = 'timesheet-import';
                break;
            case '/quoterequests/list':
                heading = 'quoteRequests';
                break;
            case '/customers/list':
                heading = 'clients';
                break;
            case '/contacts/list':
                heading = 'contacts';
                break;
            case '/leads/list':
                heading = 'leads';
                break;
            case '/dashboard':
                heading = 'dashboard';
                break;
            case '/account/details':
            case '/account/users':
            case '/account/subscription':
                heading = 'businessAccount';
                break;
            case '/account/setup/buildingtypes':
            case '/account/setup/businessdocuments':
            case '/account/setup/contacttypes':
            case '/account/setup/contactgroups':
            case '/account/setup/customersources':
            case '/account/setup/unitmeasures':
            case '/account/setup/taxrates':
            case '/account/setup/customertypes':
                heading = 'businessSetup';
                break;
            case '/account/integrations':
                heading = 'integrations';
                break;
            case '/account/api/webhooks':
                heading = 'webhooks';
                break;
            case '/account/api/eventlog':
                heading = 'eventlog';
                break;
            case '/messages/email':
                heading = 'email';
                break;
            case '/messages/email-senders':
                heading = 'emailSenders';
                break;
            case '/messages/sms':
                heading = 'sms';
                break;
            case '/messages/notifications':
                heading = 'notifications';
                break;
            case '/messages/conversations':
                heading = 'conversations';
                break;
            case '/price/price-list':
                heading = 'catalogues';
                break;
            case '/integrations/integrations-list':
            case '/account/setup/integrations':
                heading = 'integrations';
                break;
            case '/preview-features':
                heading = 'labs';
                break;
            case '/resources/partners':
                heading = 'partners';
                break;
            case '/resources/watch-and-learn':
                heading = 'watch-and-learn';
                break;
        }

        // Child route is /:addonId, which is not constant, so we need to check for it separately
        if (!heading && currentUrlRoute.startsWith('/integrations/buildxact-add-ons')) {
            heading = 'buildxactAddOns';
        }

        this.heading = heading;
    }
}
